module.exports = __webpack_public_path__ + "media/images/emblems/Maggia-coat_of_arms-93a5420d0b33e9fadf57176490ae3231.svg";